"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2232],{

/***/ 90152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ InThePressLogos; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./public/images/landing_page/press/tech-crunch-logo.png
/* harmony default export */ var tech_crunch_logo = ({"src":"/_next/static/media/tech-crunch-logo.ea4078a1.png","height":64,"width":367,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAADFBMVEV5eXn////6+vrHx8e0BhxVAAAABHRSTlMVFzAXkajH9gAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAABFJREFUeJxjYGJiZGRmYGAAAAA+AAoZtRbpAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/press/yahoo-logo.png
/* harmony default export */ var yahoo_logo = ({"src":"/_next/static/media/yahoo-logo.d41a4991.png","height":64,"width":311,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAABlBMVEXp6enq6upapB3vAAAAAnRSTlMXHokfdM0AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAVSURBVHicY2BgZGBkZGBggJCMjAwAAFEACMP1RBYAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/landing_page/press/wash-u-logo.png
/* harmony default export */ var wash_u_logo = ({"src":"/_next/static/media/wash-u-logo.bb6a1fef.png","height":64,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAABlBMVEX///////9VfPVsAAAAAnRSTlMNF0DuNrIAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAMSURBVHicY2BkgAAAABEAAvIZoJkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/landing_page/press/tech-crunch-logo-mobile.png
/* harmony default export */ var tech_crunch_logo_mobile = ({"src":"/_next/static/media/tech-crunch-logo-mobile.ec7279ee.png","height":48,"width":275,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAACVBMVEXp6el8fHz9/f2heC18AAAAA3RSTlMXFDDraJbSAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAEUlEQVR4nGNgYmJgYGBkZAQAAC0ACMhnqGEAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./public/images/landing_page/press/yahoo-logo-mobile.png
/* harmony default export */ var yahoo_logo_mobile = ({"src":"/_next/static/media/yahoo-logo-mobile.afeb1c65.png","height":48,"width":233,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAABlBMVEXp6enr6+s1enYPAAAAAnRSTlMdFn0rFHUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAUSURBVHicY2BkYGRgABMMDIwgGgAAUwAIEIeOdQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/landing_page/press/wash-u-logo-mobile.png
/* harmony default export */ var wash_u_logo_mobile = ({"src":"/_next/static/media/wash-u-logo-mobile.9e1ed7bf.png","height":56,"width":420,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAABlBMVEX///////9VfPVsAAAAAnRSTlMOFhzEVecAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAMSURBVHicY2BkgAAAABEAAvIZoJkAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./components/page-sections/InThePress/InThePressLogos.tsx










function InThePressLogos() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: classnames_default()("flex justify-center px-8 pt-22 md:pt-30"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col flex-wrap items-center justify-center gap-12 md:hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-lg text-center font-inter text-dawnDark-200",
                        children: "In the Press"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex gap-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                passHref: true,
                                href: "https://techcrunch.com/2022/02/07/dawn-health-leverages-cognitive-behavioral-therapy-for-insomnia-to-help-you-sleep-better/?guccounter=1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: tech_crunch_logo_mobile,
                                        height: 24,
                                        width: 137,
                                        alt: "Tech Crunch"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                passHref: true,
                                href: "https://sg.finance.yahoo.com/news/dawn-health-leverages-cognitive-behavioral-140003018.html",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: yahoo_logo_mobile,
                                        height: 24,
                                        alt: "Yahoo! Finance",
                                        width: 116
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "https://skandalaris.wustl.edu/blog/2022/01/12/dawn-health-overcome-insomnia/",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: wash_u_logo_mobile,
                                height: 28,
                                alt: "Washington University St. Louis",
                                width: 210
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-wrap items-center justify-center hidden gap-12 md:flex",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-lg text-center font-inter text-dawnDark-200",
                        children: "In the Press"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        href: "https://techcrunch.com/2022/02/07/dawn-health-leverages-cognitive-behavioral-therapy-for-insomnia-to-help-you-sleep-better/?guccounter=1",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: tech_crunch_logo,
                                height: 32,
                                width: 183,
                                alt: "Tech Crunch"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        passHref: true,
                        href: "https://sg.finance.yahoo.com/news/dawn-health-leverages-cognitive-behavioral-140003018.html",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: yahoo_logo,
                                height: 32,
                                alt: "Yahoo! Finance",
                                width: 155
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "https://skandalaris.wustl.edu/blog/2022/01/12/dawn-health-overcome-insomnia/",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: wash_u_logo,
                                height: 32,
                                alt: "Washington University St. Louis",
                                width: 240
                            })
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 33732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* reexport */ InThePress; },
  "P": function() { return /* reexport */ InThePressLogos/* InThePressLogos */.P; }
});

// EXTERNAL MODULE: ./components/page-sections/InThePress/InThePressLogos.tsx + 6 modules
var InThePressLogos = __webpack_require__(90152);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./public/images/landing_page/tech-crunch-logo/tech-crunch-logo-mobile-gray.png
/* harmony default export */ var tech_crunch_logo_mobile_gray = ({"src":"/_next/static/media/tech-crunch-logo-mobile-gray.49f83f66.png","height":480,"width":622,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAJ1BMVEWjo6ONjY2tra3Q0NCcnJza2tqxsbHDw8O3t7fz8/PLy8upqamUlJTP1CtmAAAAAnRSTlP8/HqR3b4AAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAvSURBVHicBcGHAQAwCAIwBLf9/94mMLPnDuBVFXYJ14QkwjE9sYnj9oYS5CWZ/QEZegEAZ87B5QAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./public/images/landing_page/tech-crunch-logo/tech-crunch-logo-mobile-green.png
/* harmony default export */ var tech_crunch_logo_mobile_green = ({"src":"/_next/static/media/tech-crunch-logo-mobile-green.ed505e5a.png","height":480,"width":622,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAUVBMVEUApF2A4ZQyxWug4r4A0AEvvHV10KozvXUmyU8etHCL2bLc9OcEzxGW4bQWzS8sx1sNq2oEqGT0+/cbyEJAzmh02Zc+xXht3YJr43Gy58tXzYnpP1sWAAAACXRSTlP8////////8/6cctTAAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAOUlEQVR4nAXBiQGAIAwEsAPa6vH7AOr+g5oAwEFyQzczjdGD4XxLcTuo6UthVOgc93JPhm9XzSLyAy+nAfmQr6JSAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/tech-crunch-logo/tech-crunch-logo-desktop-gray.png
/* harmony default export */ var tech_crunch_logo_desktop_gray = ({"src":"/_next/static/media/tech-crunch-logo-desktop-gray.9ae12f05.png","height":480,"width":602,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAJ1BMVEWmpqaPj4+vr6/R0dGbm5vKysqqqqq3t7f09PTb29uLi4uQkJDExMSVA2oCAAAAAnRSTlP6+VyhjrcAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAAuSURBVHicBcGHAQAgDAIwBDr1/3tNcHavbcAvHqSE1SMFYXT1BJGM0ogAk0zWBxrEAOqjUXdrAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./public/images/landing_page/tech-crunch-logo/tech-crunch-logo-desktop-green.png
/* harmony default export */ var tech_crunch_logo_desktop_green = ({"src":"/_next/static/media/tech-crunch-logo-desktop-green.796cfab1.png","height":480,"width":602,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAASFBMVEUAolwquXR+068IqmYbsm6Z37kA0AE0xWsZx0E2wnQqylYXzTDe9eh63Jp13owEzxKQ6ZhVzIhCzmqS4a7z+/eP27Ry5Xiu5clwceuMAAAACXRSTlP9////////7v50ZayfAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAN0lEQVR4nAXBiQHAIAgEsAMBxV9b7f6bNgGAICKOwMykxyH6fvq0DKK6qvYC97b7vAMxpzLM7Ack7wGrDLgjXwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./components/page-sections/InThePress/InThePress.tsx








function ImageOnHover(param) {
    var defaultImage = param.defaultImage, onHoverImage = param.onHoverImage, width = param.width, height = param.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        style: {
            width: width,
            height: height
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: onHoverImage,
                layout: "fill",
                alt: "Tech Crunch logo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "transition-opacity duration-300 ease-in-out group-hover:opacity-0 group-active:opacity-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: defaultImage,
                    layout: "fill",
                    alt: "Tech Crunch logo"
                })
            })
        ]
    });
}
function InThePress(param) {
    var useDarkBackground = param.useDarkBackground;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()("flex justify-center px-8 py-22 md:py-30", "".concat(useDarkBackground ? "bg-dawnDark-700 text-white" : "bg-white")),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-[822px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-2xl font-semibold text-center font-inter md:text-4xl",
                    children: "In the Press"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "https://techcrunch.com/2022/02/07/dawn-health-leverages-cognitive-behavioral-therapy-for-insomnia-to-help-you-sleep-better/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        className: "flex flex-col md:flex-row md:h-[240px] mt-10 md:mt-14 group",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden md:block",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageOnHover, {
                                    defaultImage: tech_crunch_logo_desktop_gray,
                                    onHoverImage: tech_crunch_logo_desktop_green,
                                    width: 301,
                                    height: 240
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mx-auto md:hidden",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageOnHover, {
                                    defaultImage: tech_crunch_logo_mobile_gray,
                                    onHoverImage: tech_crunch_logo_mobile_green,
                                    width: 311,
                                    height: 240
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("md:px-8 px-6 md:-mt-0 border-l md:border-t border-b border-r rounded-b-xl md:rounded-r-xl md:border-l-0 max-w-[311px] md:max-w-none", "".concat(useDarkBackground ? "border-dawnDark-400" : "border-dawnDark-150")),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "pt-6 text-xl font-semibold leading-8 md:text-2xl md:leading-10 md:pt-5",
                                        children: "\u201CFor those whose insomnia has taken over, Dawn Health, an insomnia treatment startup, wants to put you back in control over your sleep.\u201D"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: classnames_default()("md:text-xl md:leading-8 font-inter mt-2 pb-6 md:pb-0 text-base", "".concat(useDarkBackground ? "" : "text-dawnDark-500")),
                                        children: "- Christine Hall, TechCrunch"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/page-sections/InThePress/index.ts




/***/ }),

/***/ 39021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* reexport */ TestimonialCarousel; },
  "H": function() { return /* reexport */ Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/embla-carousel-react/embla-carousel-react.esm.js
var embla_carousel_react_esm = __webpack_require__(25585);
// EXTERNAL MODULE: ./utils/tailwindConfig.ts
var tailwindConfig = __webpack_require__(30049);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/page-sections/Testimonials/Testimonials.tsx






var tailwindScreenBreakpoins = (tailwindConfig/* theme */.r === null || tailwindConfig/* theme */.r === void 0 ? void 0 : tailwindConfig/* theme.screens */.r.screens) || {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px"
};
function DotButton(param) {
    var isSelected = param.isSelected, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        "aria-label": "Toggle testimonial",
        onClick: onClick,
        className: "w-2 h-2 rounded-full ".concat(isSelected ? "bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500" : "bg-white bg-opacity-5")
    });
}
function TestimonialBox(param) {
    var text = param.text, source = param.source, _isActive = param.isActive, isActive = _isActive === void 0 ? false : _isActive;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("relative flex-grow-0 flex-shrink-0 w-10/12 px-2 md:px-4 md:w-4/6 xl:w-1/3 md:pr-4 xl:pr-8", {
            "opacity-40 xl:opacity-100": !isActive
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col justify-between h-full p-8 bg-white bg-opacity-5 rounded-2xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "text-lg leading-8 text-white md:text-2xl md:leading-10 font-inter",
                        children: [
                            "\u201C",
                            text,
                            "\u201D"
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex items-center mt-4 space-x-3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "font-medium",
                            children: [
                                "- ",
                                source
                            ]
                        })
                    })
                })
            ]
        })
    });
}
function getActiveBreakpoints(breakpoints) {
    return Object.keys(breakpoints).filter(function(breakpoint) {
        return window.matchMedia("(min-width: ".concat(breakpoints[breakpoint], ")")).matches;
    });
}
function createEmblaCarouselConfig() {
    var activeBreakpoints = getActiveBreakpoints(tailwindScreenBreakpoins);
    var slidesToScroll = activeBreakpoints.includes("xl") ? 3 : 1;
    return {
        slidesToScroll: slidesToScroll,
        draggable: slidesToScroll <= 2,
        align: "center",
        startIndex: 1,
        loop: true
    };
}
function Testimonials(param) {
    var _showTitle = param.showTitle, showTitle = _showTitle === void 0 ? true : _showTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "py-16 bg-dawnDark-700 md:py-30",
        children: [
            showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mb-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                    className: "mx-8 text-3xl font-semibold text-center text-white md:text-5xl md:text-left",
                    children: [
                        "More Sleep.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                            className: "md:hidden"
                        }),
                        " Less Worries."
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialCarousel, {})
        ]
    });
}
function TestimonialCarousel() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,embla_carousel_react_esm/* default */.Z)(), 2), emblaCarouselRef = ref[0], emblaCarousel = ref[1];
    var ref1 = (0,react.useState)([]), scrollSnaps = ref1[0], setScrollSnaps = ref1[1];
    var ref2 = (0,react.useState)(1), selectedIndex = ref2[0], setSelectedIndex = ref2[1];
    var onSelect = (0,react.useCallback)(function() {
        if (!emblaCarousel) {
            return;
        }
        setSelectedIndex(emblaCarousel.selectedScrollSnap());
    }, [
        emblaCarousel,
        setSelectedIndex
    ]);
    var scrollTo = (0,react.useCallback)(function(index) {
        return emblaCarousel && emblaCarousel.scrollTo(index);
    }, [
        emblaCarousel
    ]);
    (0,react.useEffect)(function() {
        if (!emblaCarousel) {
            return;
        }
        setScrollSnaps(emblaCarousel.scrollSnapList());
        emblaCarousel.reInit(createEmblaCarouselConfig());
        emblaCarousel.on("select", onSelect);
        emblaCarousel.on("resize", function() {
            emblaCarousel.reInit(createEmblaCarouselConfig());
        });
    }, [
        emblaCarousel,
        setScrollSnaps,
        onSelect
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: emblaCarouselRef,
                    className: "overflow-hidden max-w-7xl",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialBox, {
                                text: "The only approach that has tangibly improved my mental health in the long run. It is simple, long-lasting and sustainable.",
                                source: "Ilya V.",
                                isActive: selectedIndex === 0
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialBox, {
                                text: "I've spent a lot of money trying different things for my mental health. Dawn's CBT program was the only thing that made a difference.",
                                source: "Kevin L.",
                                isActive: selectedIndex === 1
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TestimonialBox, {
                                text: "I have been falling asleep within 10-15 mins. Dawn has been a huge improvement to my life and I\u2019m really glad I gave it a try.",
                                source: "Andrew K.",
                                isActive: selectedIndex === 2
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt-4 xl:hidden pb-9 md:pb-28 xl:pb-52",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex space-x-2",
                    children: scrollSnaps.map(function(_, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DotButton, {
                            onClick: function() {
                                return scrollTo(index);
                            },
                            isSelected: selectedIndex === index
                        }, index);
                    })
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/page-sections/Testimonials/index.ts



/***/ }),

/***/ 6512:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ Le; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_match_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32984);
/* harmony import */ var _utils_render_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12351);
/* harmony import */ var _hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23784);
/* harmony import */ var _hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19946);
/* harmony import */ var _keyboard_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61363);
/* harmony import */ var _utils_bugs_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64103);
/* harmony import */ var _internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16567);
/* harmony import */ var _hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(14157);
/* harmony import */ var _utils_owner_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15466);
/* harmony import */ var _hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73781);
var J=(l=>(l[l.Open=0]="Open",l[l.Closed=1]="Closed",l))(J||{}),Q=(t=>(t[t.ToggleDisclosure=0]="ToggleDisclosure",t[t.CloseDisclosure=1]="CloseDisclosure",t[t.SetButtonId=2]="SetButtonId",t[t.SetPanelId=3]="SetPanelId",t[t.LinkPanel=4]="LinkPanel",t[t.UnlinkPanel=5]="UnlinkPanel",t))(Q||{});let V={[0]:e=>({...e,disclosureState:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(e.disclosureState,{[0]:1,[1]:0})}),[1]:e=>e.disclosureState===1?e:{...e,disclosureState:1},[4](e){return e.linkedPanel===!0?e:{...e,linkedPanel:!0}},[5](e){return e.linkedPanel===!1?e:{...e,linkedPanel:!1}},[2](e,n){return e.buttonId===n.buttonId?e:{...e,buttonId:n.buttonId}},[3](e,n){return e.panelId===n.panelId?e:{...e,panelId:n.panelId}}},B=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);B.displayName="DisclosureContext";function v(e){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(B);if(n===null){let l=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(l,v),l}return n}let h=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);h.displayName="DisclosureAPIContext";function K(e){let n=(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(h);if(n===null){let l=new Error(`<${e} /> is missing a parent <Disclosure /> component.`);throw Error.captureStackTrace&&Error.captureStackTrace(l,K),l}return n}let H=(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);H.displayName="DisclosurePanelContext";function X(){return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(H)}function Y(e,n){return (0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(n.type,V,e,n)}let Z=react__WEBPACK_IMPORTED_MODULE_0__.Fragment,ee=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let{defaultOpen:y=!1,...u}=n,T=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),t=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(l,(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .optionalRef */ .h)(a=>{T.current=a},n.as===void 0||n.as===react__WEBPACK_IMPORTED_MODULE_0__.Fragment)),o=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),f=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),s=(0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(Y,{disclosureState:y?0:1,linkedPanel:!1,buttonRef:f,panelRef:o,buttonId:null,panelId:null}),[{disclosureState:i,buttonId:p},D]=s,d=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(a=>{D({type:1});let r=(0,_utils_owner_js__WEBPACK_IMPORTED_MODULE_5__/* .getOwnerDocument */ .r)(T);if(!r||!p)return;let c=(()=>a?a instanceof HTMLElement?a:a.current instanceof HTMLElement?a.current:r.getElementById(p):r.getElementById(p))();c==null||c.focus()}),P=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({close:d}),[d]),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:i===0,close:d}),[i,d]),S={ref:t};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(B.Provider,{value:s},react__WEBPACK_IMPORTED_MODULE_0__.createElement(h.Provider,{value:P},react__WEBPACK_IMPORTED_MODULE_0__.createElement(_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .OpenClosedProvider */ .up,{value:(0,_utils_match_js__WEBPACK_IMPORTED_MODULE_1__/* .match */ .E)(i,{[0]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Open */ .ZM.Open,[1]:_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Closed */ .ZM.Closed})},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:S,theirProps:u,slot:A,defaultTag:Z,name:"Disclosure"}))))}),te="button",ne=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let y=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__/* .useId */ .M)(),{id:u=`headlessui-disclosure-button-${y}`,...T}=n,[t,o]=v("Disclosure.Button"),f=X(),s=f===null?!1:f===t.panelId,i=(0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null),p=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(i,l,s?null:t.buttonRef);(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{if(!s)return o({type:2,buttonId:u}),()=>{o({type:2,buttonId:null})}},[u,o,s]);let D=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{var c;if(s){if(t.disclosureState===1)return;switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),o({type:0}),(c=t.buttonRef.current)==null||c.focus();break}}else switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Enter */ .R.Enter:r.preventDefault(),r.stopPropagation(),o({type:0});break}}),d=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{switch(r.key){case _keyboard_js__WEBPACK_IMPORTED_MODULE_8__/* .Keys.Space */ .R.Space:r.preventDefault();break}}),P=(0,_hooks_use_event_js__WEBPACK_IMPORTED_MODULE_4__/* .useEvent */ .z)(r=>{var c;(0,_utils_bugs_js__WEBPACK_IMPORTED_MODULE_9__/* .isDisabledReactIssue7711 */ .P)(r.currentTarget)||n.disabled||(s?(o({type:0}),(c=t.buttonRef.current)==null||c.focus()):o({type:0}))}),A=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.disclosureState===0}),[t]),S=(0,_hooks_use_resolve_button_type_js__WEBPACK_IMPORTED_MODULE_10__/* .useResolveButtonType */ .f)(n,i),a=s?{ref:p,type:S,onKeyDown:D,onClick:P}:{ref:p,id:u,type:S,"aria-expanded":n.disabled?void 0:t.disclosureState===0,"aria-controls":t.linkedPanel?t.panelId:void 0,onKeyDown:D,onKeyUp:d,onClick:P};return (0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:a,theirProps:T,slot:A,defaultTag:te,name:"Disclosure.Button"})}),le="div",re=_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.RenderStrategy */ .AN.RenderStrategy|_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .Features.Static */ .AN.Static,oe=(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .forwardRefWithAs */ .yV)(function(n,l){let y=(0,_hooks_use_id_js__WEBPACK_IMPORTED_MODULE_7__/* .useId */ .M)(),{id:u=`headlessui-disclosure-panel-${y}`,...T}=n,[t,o]=v("Disclosure.Panel"),{close:f}=K("Disclosure.Panel"),s=(0,_hooks_use_sync_refs_js__WEBPACK_IMPORTED_MODULE_3__/* .useSyncRefs */ .T)(l,t.panelRef,P=>{o({type:P?4:5})});(0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>(o({type:3,panelId:u}),()=>{o({type:3,panelId:null})}),[u,o]);let i=(0,_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .useOpenClosed */ .oJ)(),p=(()=>i!==null?i===_internal_open_closed_js__WEBPACK_IMPORTED_MODULE_6__/* .State.Open */ .ZM.Open:t.disclosureState===0)(),D=(0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>({open:t.disclosureState===0,close:f}),[t,f]),d={ref:s,id:u};return react__WEBPACK_IMPORTED_MODULE_0__.createElement(H.Provider,{value:t.panelId},(0,_utils_render_js__WEBPACK_IMPORTED_MODULE_2__/* .render */ .sY)({ourProps:d,theirProps:T,slot:D,defaultTag:le,features:re,visible:p,name:"Disclosure.Panel"}))}),Le=Object.assign(ee,{Button:ne,Panel:oe});


/***/ })

}]);